import PropTypes from 'prop-types'
import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
const colorBackgroundStandard = 'var(--colorBackgroundStandard, var(--coreColorNeutral0))'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'

import Branding from 'components/branding'
import _StyledContainer from "container-StyledContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/scheduling_links/container.js?styleId=StyledContainer";


const StyledContainer = /*#__PURE__*/styled('div', null, {
  displayName: "StyledContainer",
  styles: _StyledContainer,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletUp: useDeviceType('isTabletUp'),
    isTabletDown: useDeviceType('isTabletDown'),
    isDesktopUp: useDeviceType('isDesktopUp')
  })
})

export const SchedulingLinkContainer = ({
  children,
  expanded = false,
  hiddenSidebar = false,
  ...props
}) => (
  <StyledContainer
    {...props}
    expanded={expanded}
    hiddenSidebar={hiddenSidebar}
    data-id="scheduling-link-container"
    data-container="booking-container"
  >
    <Branding />
    {children}
  </StyledContainer>
)

SchedulingLinkContainer.propTypes = {
  expanded: PropTypes.bool,
  hiddenSidebar: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
}
